import React, { useState, useEffect } from 'react';
import '../styles/Common.css'; // 공통 스타일
import { DatePicker, Button, ConfigProvider, Modal, Select, InputNumber, message, Table, Space, Checkbox } from 'antd';
import axios from 'axios';  // axios 임포트
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import ko_KR from 'antd/es/locale/ko_KR';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { buildApiUrl } from '../config/api';

dayjs.extend(customParseFormat);
dayjs.locale('ko');

const OrderVolumePage = () => {
  const [startDate, setStartDate] = useState(null); // 시작일을 null로 초기화
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [orderDate, setOrderDate] = useState(dayjs());
  const [quantity, setQuantity] = useState(1);
  const [selectedPart, setSelectedPart] = useState(null); // 품목 선택 상태 추가
  const [deliveryType, setDeliveryType] = useState(null); // 배송 선택 상태 추가
  const [orderData, setOrderData] = useState([]); // 서버에서 가져온 데이터를 저장할 상태 추가
  const [capaData, setCapaData] = useState([]); // 서버에서 가져온 CAPA 데이터를 저장할 상태 추가
  const [isDateSelected, setIsDateSelected] = useState(false); // 날짜 선택 여부 상태 추가
  const [isOrderHistoryModalVisible, setIsOrderHistoryModalVisible] = useState(false); // 발주 내역 모달 상태
  const [orderHistory, setOrderHistory] = useState([]); // 발주 내역 상태
  const [isEditModalVisible, setIsEditModalVisible] = useState(false); // 수정 모달 상태
  const [editingRecord, setEditingRecord] = useState(null); // 수정할 데이터 저장
  const [scrollMode, setScrollMode] = useState(false); // 스크롤 모드 상태 추가
  const [visibleDays, setVisibleDays] = useState(3); // 보이는 날의 범위 초기값


  const partNames = ['허니콤', '3D', '콤비', '롤', '우드', '베네시안', '루미나리', '커튼', '전동'];

  const handleInputChange = (setter) => (value) => setter(value);  // 일반화된 핸들러

  const showModal = () => setIsModalVisible(true);

  const handleScrollModeChange = (e) => {
    setScrollMode(e.target.checked);
    if (e.target.checked) {
      fetchScrollModeData(); // 스크롤 모드일 경우 데이터를 가져옴
    }
  };
  const handleScroll = () => {
    setVisibleDays(prev => prev + 3); // 3일씩 늘려서 가져옴
    fetchScrollModeData(); // 새로 데이터를 가져옴
  };
  const fetchScrollModeData = async () => {
    try {
      
    } catch (error) {
      message.error('데이터를 가져오는 중 오류가 발생했습니다.');
    }
  };
  const handleOk = async () => {
    if (!selectedPart || !orderDate || !quantity || deliveryType === null) {
      message.error('모든 필드를 선택해 주세요.');
      return;
    }

    const userID = localStorage.getItem('User_ID'); // localStorage에서 User_ID 가져오기

    try {
      const response = await axios.post(buildApiUrl('/api/order/add'), {
        PartName: selectedPart,
        Order_DT: orderDate.format('YYYY-MM-DD'),
        Count: quantity,
        Type: deliveryType === 'option1' ? '화물' : '납품', // 배송 타입 설정
        User_ID: userID,
      });

      if (response.status === 200 && response.data.message === '발주가 추가되었습니다.') {
        message.success(response.data.message);
        setIsModalVisible(false);
        fetchOrderData(startDate); // 데이터를 새로 가져옴
      } else {
        message.error('발주 추가에 실패했습니다. ' + response.data.message);
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('서버 오류가 발생했습니다: ' + error.message);
    }
  };

  const handleCancel = () => setIsModalVisible(false);

  const fetchOrderData = async (selectDay) => {
    if (!selectDay) return;

    try {
      const response = await axios.post(buildApiUrl('/api/order/fetch'), { SelectDay: selectDay.format('YYYY-MM-DD') });
      setOrderData(response.data); // 서버에서 받아온 데이터를 상태에 저장
    } catch (error) {
      console.error('데이터 조회 중 오류 발생:', error);
      message.error('데이터를 불러오는 중 오류가 발생했습니다.');
    }
  };

  const fetchCapaData = async () => {
    try {
      const response = await axios.get(buildApiUrl('/api/order/capa'));
      setCapaData(response.data); // 서버에서 받아온 CAPA 데이터를 상태에 저장
    } catch (error) {
      console.error('CAPA 데이터를 불러오는 중 오류 발생:', error);
      message.error('CAPA 데이터를 불러오는 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    fetchCapaData(); // 컴포넌트가 마운트될 때 CAPA 데이터를 가져옴
  }, []);

  useEffect(() => {
    if (startDate) {
      fetchOrderData(startDate); // startDate가 변경될 때마다 데이터를 새로 불러옴
      setIsDateSelected(true);
    }
  }, [startDate]);

  // 발주 내역 데이터 요청
  const fetchOrderHistory = async () => {
    const userID = localStorage.getItem('User_ID'); // User_ID 가져오기
    try {
      const response = await axios.post(buildApiUrl('/api/order/mylist'), { User_ID: userID });
      setOrderHistory(response.data); // 받아온 데이터를 상태에 저장
    } catch (error) {
      console.error('Error fetching order history:', error);
      message.error('발주 내역을 불러오는 중 오류가 발생했습니다.');
    }
  };

  // 발주 내역 모달 열기
  const openOrderHistoryModal = () => {
    setIsOrderHistoryModalVisible(true);
    fetchOrderHistory(); // 모달이 열릴 때 발주 내역을 요청
  };

  // 발주 내역 모달 닫기
  const closeOrderHistoryModal = () => {
    setIsOrderHistoryModalVisible(false);
    
  };
    // 삭제 버튼 클릭 시 처리
    const handleDelete = async (record) => {
      try {
        const response = await axios.post(buildApiUrl('/api/order/delete'), { No: record.No });
  
        if (response.status === 200) {
          message.success('발주가 삭제되었습니다.');
          setOrderHistory(orderHistory.filter((order) => order.No !== record.No)); // UI에서 항목 제거
          fetchOrderData(startDate);
        } else {
          message.error('발주 삭제에 실패했습니다.');
        }
      } catch (error) {
        console.error('Error deleting order:', error);
        message.error('서버 오류가 발생했습니다: ' + error.message);
      }
    };

// 수정 버튼 클릭 시 모달 열기 및 데이터 설정
const handleEdit = (record) => {
  setEditingRecord(record); // 수정할 데이터 설정
  setIsEditModalVisible(true); // 수정 모달 열기
};

  // 발주 내역 테이블의 컬럼 구성
  const columns = [
    {
      title: '품목명',
      dataIndex: 'PartName',
      key: 'PartName',
      align: 'center', // 중앙 정렬
    },
    {
      title: '수량',
      dataIndex: 'Count',
      key: 'Count',
      align: 'center', // 중앙 정렬
    },
    {
      title: '유형',
      dataIndex: 'Type',
      key: 'Type',
      align: 'center', // 중앙 정렬
    },
    {
      title: '발주일',
      dataIndex: 'Order_DT',
      key: 'Order_DT',
      render: (text) => dayjs(text).format('MM-DD'), // 날짜 형식 변환
      align: 'center', // 중앙 정렬
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => handleEdit(record)}>수정</Button>
          <Button type="link" danger onClick={() => handleDelete(record)}>삭제</Button>
        </Space>
      ),
      align: 'center', // 중앙 정렬
    },
  ];
  
  // 주말을 제외한 영업일 계산 함수
const getNextBusinessDay = (startDate, daysToAdd) => {
  let currentDate = dayjs(startDate);
  let addedDays = 0;

  // daysToAdd 만큼 주말을 제외한 날짜를 계산
  while (addedDays < daysToAdd) {
    currentDate = currentDate.add(1, 'day'); // 하루를 더한다
    if (currentDate.day() !== 0 && currentDate.day() !== 6) { // 주말이 아닌 경우에만 증가
      addedDays++;
    }
  }

  return currentDate;
};

// 시작일로부터 n일 뒤의 영업일을 가져오는 함수
const formatHeaderDate = (baseDate, daysToAdd) => getNextBusinessDay(baseDate, daysToAdd).format('M/D');

// 화물과 납품의 합계를 계산하는 함수
const calculateTotal = (partName, currentDate, nextDate) => {
  const cargoCount = parseInt(getOrderData(partName, '화물', currentDate), 10) || 0; // 현재 날짜의 화물
  const deliveryCount = parseInt(getOrderData(partName, '납품', nextDate), 10) || 0; // 다음 날짜의 납품
  return cargoCount + deliveryCount; // 화물과 납품의 합계
};

// 잔여 값 계산에서 영업일만 계산하도록 수정
const calculateRemaining = (partName, currentDate, nextDate) => {
  const capa = getCapaForPart(partName);
  const total = calculateTotal(partName, currentDate, nextDate); // 화물과 납품의 합계
  return capa - total; // CAPA에서 화물과 납품 합계를 뺀 값
};

  const getOrderData = (partName, type, date) => {
    const order = orderData.find(
      (o) => o.PartName === partName && o.Type === type && dayjs(o.OrderDate).format('M/D') === date
    );
    return order ? order.TotalCount : '';
  };

  const getCapaForPart = (partName) => {
    const capa = capaData.find((c) => c.PartName === partName);
    return capa ? capa.CAPA : 0;
  };

  // 잔여 값에 따른 스타일을 반환하는 함수
  const getRemainingStyle = (remaining, capa) => {
    if (remaining <= capa * 0.2) {
      return { backgroundColor: 'red', color: 'white' }; // 20% 이하인 경우 빨간색
    } else if (remaining <= capa * 0.5) {
      return { backgroundColor: 'orange', color: 'black' }; // 50% 이하인 경우 주황색
    } else {
      return {}; // 그 외의 경우 기본 스타일
    }
  };
// 수정된 데이터 서버로 전송
const handleUpdate = async () => {
  try {
    const response = await axios.post(buildApiUrl('/api/order/update'), editingRecord); // 수정 API 호출
    if (response.status === 200) {
      message.success('발주가 수정되었습니다.');
      fetchOrderHistory(); // 수정 후 데이터를 다시 가져옴
      setIsEditModalVisible(false); // 모달 닫기
      fetchOrderData(startDate);
    } else {
      message.error('발주 수정에 실패했습니다.');
    }
  } catch (error) {
    console.error('Error updating order:', error);
    message.error('서버 오류가 발생했습니다.');
  }
};
// 테이블 셀 스타일 설정
const tableCellStyle = { border: '1px solid #ddd', padding: '8px', textAlign: 'center' }; // 스타일 변경: textAlign 추가

  return (
    <ConfigProvider locale={ko_KR}>
      <div >
        <div className="common-container">
           {/* 스크롤 모드 체크박스 */}
           <Checkbox onChange={handleScrollModeChange} style={{ marginRight: '10px' }}>
            스크롤 모드
          </Checkbox>
          
          <div style={{ display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '5px', width: '100%' }}>

          {/* 날짜 선택기 (스크롤 모드일 때 숨기기) */}
          {!scrollMode && (
             <div> 
            <label style={{ marginRight: '10px' }}>시작일:</label>
            <DatePicker
              value={startDate}
              onChange={(date) => { setStartDate(date); setIsDateSelected(!!date); }}
              style={{ width: '150px' }}
              placeholder="시작일"
              format="YYYY-MM-DD"
            />
            </div>)}
            <div style={{ flexGrow: 1 }} />
            <Button
              type="primary"
              style={{ marginRight: '10px' }} // 버튼 간 간격 추가
              onClick={openOrderHistoryModal}
            >
              발주 내역
            </Button>
            <Button
              type="primary"
              style={{ backgroundColor: 'red', borderColor: 'red' }}
              onClick={showModal}
            >
              발주 추가
            </Button>
          </div>
        </div>

        {/* 발주 내역 모달 */}
        <Modal
          title="발주 내역"
          visible={isOrderHistoryModalVisible}
          onCancel={closeOrderHistoryModal}
          footer={null} // 모달 하단에 버튼을 표시하지 않음
        >
          {/* 발주 내역 테이블 */}
          <Table
            dataSource={orderHistory}
            columns={columns}
            rowKey="No"
            pagination={false} // 페이지네이션 제거 (필요 시 추가)
          />
        </Modal>

        {/* 발주 추가 모달 */}
        <Modal
          title="발주 추가"
          open={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          okText="확인"
          cancelText="취소"
        >
          <div style={{ marginBottom: '10px' }}>
            <label style={{ marginRight: '10px' }}>발주일:</label>
            <DatePicker
              value={orderDate}
              onChange={handleInputChange(setOrderDate)}
              style={{ width: '100%' }}
              format="YYYY-MM-DD"
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <Select placeholder="품목 선택" style={{ width: '100%' }} onChange={handleInputChange(setSelectedPart)}>
              {partNames.map((partNameKor) => (
                <Select.Option key={partNameKor} value={partNameKor}>
                  {partNameKor}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <Select placeholder="배송 선택" style={{ width: '100%' }} onChange={handleInputChange(setDeliveryType)}>
              <Select.Option value="option1">화물,택배</Select.Option>
              <Select.Option value="option2">픽업,배송</Select.Option>
            </Select>
          </div>
          <div>
            <label style={{ marginRight: '10px' }}>수량:</label>
            <InputNumber
              min={-1000}
              value={quantity}
              onChange={handleInputChange(setQuantity)}
              style={{ width: '100%' }}
              placeholder="수량 입력"
            />
          </div>
        </Modal>

        {/* 수정 모달 */}
        <Modal
  title="발주 수정"
  visible={isEditModalVisible}
  onCancel={() => setIsEditModalVisible(false)}
  onOk={handleUpdate} // 수정 확인 버튼 클릭 시 처리
  okText="수정"
  cancelText="취소"
>
  {/* 발주 날짜 필드 추가 */}
  <div style={{ marginBottom: '10px' }}>
    <label style={{ marginRight: '10px' }}>발주일:</label>
    <DatePicker
      value={dayjs(editingRecord?.Order_DT)}
      onChange={(date) => setEditingRecord({ ...editingRecord, Order_DT: date.format('YYYY-MM-DD') })}
      style={{ width: '100%' }}
      format="YYYY-MM-DD"
    />
  </div>
  
  <div style={{ marginBottom: '10px' }}>
    <label style={{ marginRight: '10px' }}>품목명:</label>
    <Select
      value={editingRecord?.PartName}
      style={{ width: '100%' }}
      onChange={(value) => setEditingRecord({ ...editingRecord, PartName: value })}
    >
      {partNames.map((partNameKor) => (
        <Select.Option key={partNameKor} value={partNameKor}>
          {partNameKor}
        </Select.Option>
      ))}
    </Select>
  </div>
  
  <div style={{ marginBottom: '10px' }}>
    <label style={{ marginRight: '10px' }}>수량:</label>
    <InputNumber
      min={1}
      value={editingRecord?.Count}
      onChange={(value) => setEditingRecord({ ...editingRecord, Count: value })}
      style={{ width: '100%' }}
    />
  </div>
  
  <div style={{ marginBottom: '10px' }}>
    <label style={{ marginRight: '10px' }}>배송 유형:</label>
    <Select
      value={editingRecord?.Type}
      style={{ width: '100%' }}
      onChange={(value) => setEditingRecord({ ...editingRecord, Type: value })}
    >
      <Select.Option value="화물">화물</Select.Option>
      <Select.Option value="납품">납품</Select.Option>
    </Select>
  </div>
</Modal>
      {scrollMode ? (  <div className="common-container">

            <div onScroll={handleScroll} style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th colSpan="1" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}></th>
                  
                {[...Array(visibleDays)].map((_, index) => (
                  <React.Fragment key={index}>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>
                      {dayjs().add(index, 'day').format('M/D')} 화물
                    </th>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>
                      {dayjs().add(index + 1, 'day').format('M/D')} 납품
                    </th>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                  </React.Fragment>
                ))}
                </tr>
              </thead>
              <tbody>
                {partNames.slice(0, 7).map((partName, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{partName}</td>
                    {[...Array(visibleDays)].map((_, dayIndex) => (
                      <td key={dayIndex} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                        {/* 각 날짜별로 화물 데이터 가져오기 */}
                        {getOrderData(partName, '화물', dayjs().add(dayIndex, 'day').format('M/D'))}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <th colSpan="1" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}></th>
                  
                {[...Array(visibleDays)].map((_, index) => (
                  <React.Fragment key={index}>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>
                      {dayjs().add(index+1, 'day').format('M/D')} 화물
                    </th>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>
                      {dayjs().add(index+2, 'day').format('M/D')} 납품
                    </th>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                    <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                  </React.Fragment>
                ))}
                </tr>
                {partNames.slice(7).map((partName, index) => (
                  <tr key={index}>
                    <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>{partName}</td>
                    {[...Array(visibleDays)].map((_, dayIndex) => (
                      <td key={dayIndex} style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                        {/* 각 날짜별로 화물 데이터 가져오기 */}
                        {getOrderData(partName, '화물', dayjs().add(dayIndex, 'day').format('M/D'))}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            </div>
            </div>
              
          ) : (<div>
        {isDateSelected && (
          <div className="common-container">

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th colSpan="1" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}></th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 0)} 화물</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 1)} 납품</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 1)} 화물</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 2)} 납품</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 2)} 화물</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 3)} 납품</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                </tr>
              </thead>
              <tbody>
                {partNames.slice(0, 7).map((partName, index) => {
                  const total1 = calculateTotal(partName, formatHeaderDate(startDate, 0), formatHeaderDate(startDate, 1));
                  const remaining1 = calculateRemaining(partName, formatHeaderDate(startDate, 0), formatHeaderDate(startDate, 1));
                  const total2 = calculateTotal(partName, formatHeaderDate(startDate, 1), formatHeaderDate(startDate, 2));
                  const remaining2 = calculateRemaining(partName, formatHeaderDate(startDate, 1), formatHeaderDate(startDate, 2));
                  const total3 = calculateTotal(partName, formatHeaderDate(startDate, 2), formatHeaderDate(startDate, 3));
                  const remaining3 = calculateRemaining(partName, formatHeaderDate(startDate, 2), formatHeaderDate(startDate, 3));
                  const capa = getCapaForPart(partName);

                  return (
                    <tr key={index}>
                      <td style={tableCellStyle}>{partName}</td>
                      {/* 데이터를 서버에서 가져온 값으로 채우기 */}
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '화물', formatHeaderDate(startDate, 0))}</td>
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '납품', formatHeaderDate(startDate, 1))}</td>
                      <td colSpan="2" style={tableCellStyle}>{total1}</td>
                      <td colSpan="2" style={{ ...tableCellStyle, ...getRemainingStyle(remaining1, capa) }}>{remaining1}</td> {/* 잔여 */}
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '화물', formatHeaderDate(startDate, 1))}</td>
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '납품', formatHeaderDate(startDate, 2))}</td>
                      <td colSpan="2" style={tableCellStyle}>{total2}</td>
                      <td colSpan="2" style={{ ...tableCellStyle, ...getRemainingStyle(remaining2, capa) }}>{remaining2}</td> {/* 잔여 */}
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '화물', formatHeaderDate(startDate, 2))}</td>
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '납품', formatHeaderDate(startDate, 3))}</td>
                      <td colSpan="2" style={tableCellStyle}>{total3}</td>
                      <td colSpan="2" style={{ ...tableCellStyle, ...getRemainingStyle(remaining3, capa) }}>{remaining3}</td> {/* 잔여 */}
                    </tr>
                  );
                })}
                <tr>
                  <th colSpan="1" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}></th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 1)} 화물</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 2)} 납품</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 2)} 화물</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 3)} 납품</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 3)} 화물</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>{formatHeaderDate(startDate, 4)} 납품</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>합계</th>
                  <th colSpan="2" style={{ ...tableCellStyle, backgroundColor: '#f0f0f0' }}>잔여</th>
                </tr>
                {partNames.slice(7).map((partName, index) => {
                  const total1 = calculateTotal(partName, formatHeaderDate(startDate, 1), formatHeaderDate(startDate, 2));
                  const remaining1 = calculateRemaining(partName, formatHeaderDate(startDate, 1), formatHeaderDate(startDate, 2));
                  const total2 = calculateTotal(partName, formatHeaderDate(startDate, 2), formatHeaderDate(startDate, 3));
                  const remaining2 = calculateRemaining(partName, formatHeaderDate(startDate, 2), formatHeaderDate(startDate, 3));
                  const total3 = calculateTotal(partName, formatHeaderDate(startDate, 3), formatHeaderDate(startDate, 4));
                  const remaining3 = calculateRemaining(partName, formatHeaderDate(startDate, 3), formatHeaderDate(startDate, 4));
                  const capa = getCapaForPart(partName);

                  return (
                    <tr key={index}>
                      <td style={tableCellStyle}>{partName}</td>
                      {/* 데이터를 서버에서 가져온 값으로 채우기 */}
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '화물', formatHeaderDate(startDate, 1))}</td>
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '납품', formatHeaderDate(startDate, 2))}</td>
                      <td colSpan="2" style={tableCellStyle}>{total1}</td>
                      <td colSpan="2" style={{ ...tableCellStyle, ...getRemainingStyle(remaining1, capa) }}>{remaining1}</td> {/* 잔여 */}
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '화물', formatHeaderDate(startDate, 2))}</td>
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '납품', formatHeaderDate(startDate, 3))}</td>
                      <td colSpan="2" style={tableCellStyle}>{total2}</td>
                      <td colSpan="2" style={{ ...tableCellStyle, ...getRemainingStyle(remaining2, capa) }}>{remaining2}</td> {/* 잔여 */}
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '화물', formatHeaderDate(startDate, 3))}</td>
                      <td colSpan="2" style={tableCellStyle}>{getOrderData(partName, '납품', formatHeaderDate(startDate, 4))}</td>
                      <td colSpan="2" style={tableCellStyle}>{total3}</td>
                      <td colSpan="2" style={{ ...tableCellStyle, ...getRemainingStyle(remaining3, capa) }}>{remaining3}</td> {/* 잔여 */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}</div>
        )}
      </div>
    </ConfigProvider>
  );
};

export default OrderVolumePage;
